import { showToast } from 'stores/ToastStore';
import i18next from 'i18next';
import client from './rest/AdminClient';

export const getCarrierPreferences = (id) => {
  return _getCarrierPreferences(id).then(
    (response) => {
      console.log(response);
      return response.entity.data.items;
    },
    (error) => {
      console.log(error);
      showToast('Unable to fetch preferred Carriers', 'error');
      throw error;
    },
  );
};

const _getCarrierPreferences = (id) => {
  return client({
    method: 'GET',
    path: `/api/1/shippers/${id}/carrier-preferences`,
  });
};

export const updateCarrierPreferences = (id, updates) => {
  return _updateCarrierPreferences(id, updates).then(
    (response) => {
      showToast(
        i18next.t('UPDATE_CARRIER_PREFERENCES'),
        i18next.t('CARRIER_PREF_SAVED_SUCCESS'),
      );
      return response.entity.data;
    },
    (error) => {
      showToast(
        i18next.t('ERROR_UPDATE_CARRIER_PREFERENCES'),
        i18next.t('ERROR_UDPATING_CARRIER_PREF'),
      );
      throw error;
    },
  );
};

const _updateCarrierPreferences = (id, payload) => {
  return client({
    method: 'POST',
    path: `/api/1/shippers/${id}/carrier-preferences`,
    entity: JSON.stringify(payload),
  });
};
